class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-menu-clickable-region');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// mobile menu handler
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.parentNode.classList.remove('active');
						}
					});
					link.parentNode.classList.toggle('active');
				});
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		// mega menu handler
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {
				link.addEventListener('click', () => {
					const isOpen = link.classList.toggle('active');
					const linksArray = Array.from(this.megaMenuLinks);
					const anyOpen = linksArray.some((menuLink) =>
						menuLink.classList.contains('active')
					);
					document.body.classList.toggle('position-fixed', anyOpen);
					this.el.classList.toggle('mega-menu-active', anyOpen);

					if (isOpen && anyOpen) {
						linksArray.forEach((closeLink) => {
							if (closeLink !== link && closeLink.classList.contains('active')) {
								closeLink.classList.remove('active');
							}
						});
					}
				});
			});
		}

		// Close the menu when clicking outside
		document.addEventListener('click', (event) => {
			if (!event.target.closest('.menu')) {
				this.megaMenuLinks.forEach((link) => {
					link.classList.remove('active');
				});
				document.body.classList.remove('position-fixed');
				this.el.classList.remove('mega-menu-active');
			}
		});
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
